<script setup lang="ts">
import { useMe } from '../composables/useMe';
import { reviewNavItems } from '../nav';

const { data: me } = useMe();
</script>

<template>
  <div>
    <h1>Access Review</h1>
    <p v-if="me" class="mb-4">Signed in as {{ me.name }}.</p>

    <div class="home-grid">
      <v-card
        v-for="item in reviewNavItems"
        :key="item.reviewType"
        :to="{ name: 'reviews', params: { reviewType: item.reviewType } }"
        flat
        border
      >
        <v-card-item>
          <template #prepend>
            <v-icon :icon="item.icon" size="large" />
          </template>
          <v-card-title>{{ item.label }}</v-card-title>
        </v-card-item>
        <v-card-text>{{ item.description }}</v-card-text>
      </v-card>
    </div>
  </div>
</template>

<style scoped>
.home-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: 1rem;
}
</style>
